import { useToast } from '@chakra-ui/react';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import DistributionModuleFormUI from '@Modules/terminalManagementSystem/gabManagement/components/formUI/terminal/terminal/DistributionModuleFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import {
  getCounterDataTableColumns,
  TCounterDataTableData,
} from './CounterDataTableMeta';
import distributionModuleFormMeta from './meta/DistributionModuleFormMeta';

const DistributionModuleMixedHandler = () => {
  const [rowDataTable, setRowDataTable] = React.useState<TCounterDataTableData>(
    {
      primaryKey: '',
      tape: 0,
      remaining: 0,
      rejected: 0,
      dispensed: 0,
      value: 0,
      currency: 'CFA Franc BEAC',
      tapeIn: false,
    }
  );

  const toast = useToast();

  //   Initialize react Query to GET Data
  const counterQueryKey = ['Terminal-DistributionModule-Counter'];
  const { data: counterDataTable, isLoading: isLoadingCounter } = useQuery({
    queryKey: counterQueryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const queryKey = ['Terminal-DistributionModule'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const columns = getCounterDataTableColumns({
    isLoadingCounter,
  });

  return (
    <>
      <CustomReactTable data={counterDataTable || [{}, {}, {}]} columns={columns} />

      <DistributionModuleFormUI 
        meta={distributionModuleFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default DistributionModuleMixedHandler;
